import { render, staticRenderFns } from "./AssessDetailContrast.vue?vue&type=template&id=0dd480c5&scoped=true&"
import script from "./AssessDetailContrast.vue?vue&type=script&lang=js&"
export * from "./AssessDetailContrast.vue?vue&type=script&lang=js&"
import style0 from "./AssessDetailContrast.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./AssessDetailContrast.vue?vue&type=style&index=1&id=0dd480c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd480c5",
  null
  
)

export default component.exports